<template>
  <div class="com-not-img">
    <custom-plane title="小区通知" :iconImg="require('@/assets/compImg/Property/notice.png')">
      <div class="property" ref="property">
        <div class="property_bg" v-for="(item, index) in notice" :key="index">
          <div class="top">
            <div class="date">{{ item.date }}</div>
            <div class="title">{{ item.title }}</div>
          </div>
          <div class="bottom">
            {{ item.text }}
          </div>
        </div>
      </div>
    </custom-plane>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 通知信息
      notice: [
        { date: '2022-3-5', title: '全员核酸检测', text: '明天上午8:00至11:00在创业园2号楼C栋将进行全员核酸检测，请务必带好身份证原件、手机、口罩前往雪浪小镇服务中心依次排队...' },
        { date: '2022-3-2', title: '全员核酸检测', text: '明天上午8:00至11:00在创业园2号楼C栋将进行全员核酸检测，请务必带好身份证原件、手机、口罩前往雪浪小镇服务中心依次排队...' },
        { date: '2022-3-1', title: '全员核酸检测', text: '明天上午8:00至11:00在创业园2号楼C栋将进行全员核酸检测，请务必带好身份证原件、手机、口罩前往雪浪小镇服务中心依次排队...' },
        { date: '2022-2-15', title: '全员核酸检测', text: '明天上午8:00至11:00在创业园2号楼C栋将进行全员核酸检测，请务必带好身份证原件、手机、口罩前往雪浪小镇服务中心依次排队...' }
      ],
    }
  },
  // mounted() {
  //   let dom = this.$refs.property
  //   dom.innerHTML += dom.innerHTML;
  //   dom.scrollTop = 0
  //   this.time = setInterval(()=>{
  //     dom.scrollTop++
  //     if (dom.scrollTop >= dom.scrollHeight / 2) {
  //       dom.scrollTop = 0
  //     }
  //   })
  // }
};
</script>

<style lang="scss" scoped>
.com-not-img {
  width: 100%;
  height: 100%;

  .property {
    // width: 415px;
    // height: 606px;
    // overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;

    .property_bg {
      width: 389px;
      height: 132px;
      margin-top: 20px;
      padding: 20px 19px 20px 20px;
      background-image: url('../../../../../assets/compImg/Property/Property.png');
      background-size: cover;

      .top {
        display: flex;

        .date {
          width: 91px;
          height: 26px;
          color: #AFAFAF;
          font-size: 18px;
          margin-right: 12px;
        }

        .title {
          width: 120px;
          height: 26px;
          font-size: 18px;
        }
      }

      .bottom {
        margin-top: 6px;
        font-size: 14px;
        color: #AFAFAF;
        /*多行文本隐藏*/
        // -webkit-line-clamp: 3;
        // display: -webkit-box;
        // -webkit-box-orient: vertical;
        // overflow: hidden;
      }
    }
  }
}
</style>
